import { TenantSettings } from "./tenant-settings";

export abstract class TenantSettingsRepository {
  getTenantSettings: () => Promise<TenantSettings>;
  setTenantSettings: (settings: TenantSettings) => Promise<boolean>;
}
